import { FormValidator, ValidationRules } from 'src/utils/FormValidator';
import { Question } from 'src/types/helios/Question';
import { Tag } from 'src/types/helios/Tags';

export const QuestionFormValidator = (
  question?: Question | null,
  isCopyQuestion: boolean = false,
  tagsList: readonly Tag[] = [],
): FormValidator => {
  const validator = new FormValidator();

  validator
    .addRule(
      'divisionName',
      ValidationRules.required,
      'Error: Please enter the division name.',
    )
    .addRule(
      'businessUnit',
      ValidationRules.required,
      'Error: Please enter the business unit.',
    )
    .addRule(
      'defaultLanguage',
      ValidationRules.required,
      'Error: Please choose a default language.',
    )
    .addRule(
      'auditScore',
      ValidationRules.required,
      'Error: Please choose an audit score.',
    )
    .addRule('title', ValidationRules.required, 'Error: Please enter the question title.')
    .addRule(
      'questionText',
      ValidationRules.required,
      'Error: Please enter the question text.',
    )
    .addRule(
      'auditInstruction',
      ValidationRules.required,
      'Error: Please enter audit instructions.',
    )
    .addRule(
      'passCriteria',
      ValidationRules.required,
      'Error: Please enter pass criteria.',
    )
    .addRule(
      'failCriteria',
      ValidationRules.required,
      'Error: Please enter fail criteria.',
    )
    .addRule(
      'justification',
      ValidationRules.required,
      'Error: Please enter Justifications.',
    )
    .addRule(
      'tagsIncluded',
      (value) => Object.keys(value).length > 0,
      'Error: Please include at least one tag.',
    )
    .addRule(
      'tagsIncluded',
      (value) => {
        // Check if all mandatory tags are included
        const mandatoryTagGroupNames = tagsList
          .filter((tag) => tag.isMandatoryForQuestions && tag.tagGroupName)
          .map((tag) => tag.tagGroupName!);

        const selectedTagGroupNames = Object.keys(value || {});
        return mandatoryTagGroupNames.every((tagGroupName) =>
          selectedTagGroupNames.includes(tagGroupName),
        );
      },
      'Error: Please include all mandatory tags.',
    );

  if (question && !isCopyQuestion) {
    validator.addRule(
      'changeLog',
      (value) => Object.keys(value).length > 0,
      'Error: Please enter the change summary.',
    );
  }
  return validator;
};
